var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2008 5.90004L19.6694 15.134C19.1692 15.4474 18.591 15.6136 18.0008 15.6136C17.4106 15.6136 16.8323 15.4474 16.3322 15.134L1.80078 5.90004M5.04078 1.04004H30.9608C32.7502 1.04004 34.2008 2.49064 34.2008 4.28004V23.72C34.2008 25.5094 32.7502 26.96 30.9608 26.96H5.04078C3.25138 26.96 1.80078 25.5094 1.80078 23.72V4.28004C1.80078 2.49064 3.25138 1.04004 5.04078 1.04004Z",
    stroke: "#939393",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.ac51f76e0757a8339cf748a8c1558926.svg";
export { ForwardRef as ReactComponent };